import {DrawerRecommendation_LastSeenProductsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/recommendations.types';
import {useTranslation} from '@aboutyou/i18n';
import {EntityList, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {ProductTile} from '../../features/ProductTile/ProductTile';

export const NavigationLastSeenProducts = ({
  lastSeenProducts,
}: {
  lastSeenProducts: DrawerRecommendation_LastSeenProductsSection;
}) => {
  const {t} = useTranslation();
  return (
    <Container>
      <TitleWrapper>
        <Text size="px20" weight="bold" data-testid="lastSeenProductsRecoTitle">
          {lastSeenProducts.headline}
        </Text>
      </TitleWrapper>
      <SliderWrapper>
        <EntityList
          testId="lastSeenProductsReco"
          type="slider"
          slideCount={2}
          disableHeaderControl={true}
          hideSideButtons={true}
          uniqueKey="entityList_last_seen_products_reco"
        >
          {lastSeenProducts.products.map((tile, index) => (
            <ProductTile
              key={tile.productId}
              streamPosition={index}
              tile={tile}
              addCtaLabel={t('Add to basket')}
            />
          ))}
        </EntityList>
      </SliderWrapper>
    </Container>
  );
};

const Container = styled.div`
  padding-top: 20px;
`;

const TitleWrapper = styled.div`
  padding-bottom: 16px;
`;

const SliderWrapper = styled.div`
  margin: 0 -20px;
`;
